const { mapGetters, mapMutations } = require('vuex')
const FilterGroup = require('../../../../utils/getFilterGroup')

const filterGroup = new FilterGroup.FilterGroup()

module.exports = {
  data() {
    return {
      // hasSearch: [], // 已经检索过的item
      total: 0// 数据总数
    }
  },
  computed: {
    ...mapGetters('filterGroup', [
      'hasSearchMap',
    ])
  },
  methods: {
    ...mapMutations('filterGroup', [
      'updateHasSearchMap',
      'filterHasRequestTarget'
    ]),
    // 展开加载内容
    async _getFilterGroup(item, type) {
      const v = this.currentFilterItemStatus(item, type)
      if (!v) return // 不能发起请求
      try {
        const params = {
          item,
          searchParams: this.searchParams,
          sideCode: this.sideCode
        }
        const result = await filterGroup.getFilterGroup(params) // 获取侧边栏的数据
        this.handlerListResult(item, result) // 处理结果设置到配置中的list中
      } catch (error) {
        console.log(error)
        item.noticText = '暂时无数据'
      }
    },
    // 收起
    handlerPutAway(params) {
      const { item, status } = params
      item.open = status
    },
    // 加载更多
    async _loadMoreFilterGroup(item) {
      try {
        const params = {
          item,
          searchParams: this.searchParams,
          sideCode: this.sideCode
        }
        const result = await filterGroup.loadMoreFilterGroup(params) // 获取侧边栏的数据
        this.handlerListResult(item, result) // 处理结果设置到配置中的list中
      } catch (error) {
        item.noticText = '暂时无数据'
      }
    },
    // 处理结果，放入list中
    handlerListResult(item, resultInstance) {
      const {
        // isTabsGroup,
        key,
        currentIndex
        // v2percentIndex
      } = item
      const { result, total } = resultInstance
      const filterResult = result.filter((resultItem) => {
        const isObj = typeof item.key === 'object'
        const k = isObj ? key[currentIndex] : key // 获取key
        return resultItem[k]
      })
      if(filterResult.length === 0) {
        item.noticText = '暂时无数据'
      }
      item.total = total
      item.list = filterResult
      this.toTransitionV2Percent(item) // 处理百分比的结果
    },
    // 把值转为百分比
    toTransitionV2Percent(item) {
      const {
        currentIndex,
        v2percentIndex,
        // key,
        total
      } = item
      if (!v2percentIndex) return // 如果不是需要切换为百分比的group，直接退出
      const isIncludes = v2percentIndex.includes(currentIndex)
      item.list.forEach((item) => {
        if (!item.patent_num_percent) {
          const v = `${((item.patent_num / total) * 100).toFixed(2)}%`
          item.patent_num_percent = v
        }
        if (!item.patent_num_N) {
          item.patent_num_N = item.patent_num
        }
        const currentV = isIncludes ? item.patent_num_percent : item.patent_num_N
        this.$set(item, 'patent_num', currentV)
      })
    },
    // 返回标题的处理
    getTitle(instance) {
      const { name, currentIndex } = instance
      if (Array.isArray(name)) {
        return name[currentIndex]
      }
      return name
    },
    // 更新侧边栏状态
    currentFilterItemStatus(item, type = '') {
      const cantUpdateOpen = ['switch', 'ipc']
      if (!cantUpdateOpen.includes(type)) {
        item.open = !item.open
      }
      if (!item.open) return false
      if (item.isTabsGroup) return true // 内嵌tab保持发起请求
      const { name, currentIndex } = item
      let uniqueId = name
      if (typeof item.name === 'object') {
        uniqueId = name[currentIndex]
      }
      const isRequest = this.hasSearchMap.includes(uniqueId)
      if (item.controlType !== 'slider' && isRequest) return false // 展开并且请求过了
      this.updateHasSearchMap(uniqueId)
      return true
    },
    // 移除已经请求数组中目标的函数
    spliceTarget(target) {
      // this.hasSearch = this.hasSearch.filter((item) => item !== target)
      this.filterHasRequestTarget(target)
    }
  }
}